<div
  [formGroup]="form"
  class="flex justify-between gap-4 py-2 px-6 items-center"
>
  <mat-form-field class="input-tg mt-message-input w-2/4" appearance="outline">
    <mat-label>Nome</mat-label>
    <input matInput formControlName="name" />
  </mat-form-field>
  <mat-form-field class="input-tg mt-message-input w-2/4" appearance="outline">
    <mat-label>Descrição</mat-label>
    <input matInput formControlName="description" />
  </mat-form-field>
  <button
    mat-flat-button
    class="btn-tg w-1/5"
    [disabled]="form.invalid || loading"
    (click)="createItem()"
  >
    @if (loading) {
      <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
    } @else {
      Adicionar Novo
    }
  </button>
  <!--  <button mat-flat-button class="btn-tg w-full mt-6" [disabled]="!checkForm()" (click)="sendLogin()">entrar</button>-->
</div>
